import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const Container = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30063520__sc-1r2ixv-0"
})(["display:flex;margin-top:2px;"]);
const ImageContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30063520__sc-1r2ixv-1"
})(["min-width:70px;max-width:70px;margin-inline-end:", ";"], ({
  theme
}) => theme.spacing.small);
const Grid = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30063520__sc-1r2ixv-2"
})(["width:100%;", ""], ({
  $minColumnWidth
}) => ({
  'column-width': `${$minColumnWidth}px`
}));
const Row = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30063520__sc-1r2ixv-3"
})(["margin-bottom:2px;page-break-inside:avoid;break-inside:avoid;"]);
const DataItem = /*#__PURE__*/styled.dl.withConfig({
  componentId: "sc-storm-ui-30063520__sc-1r2ixv-4"
})(["margin-block-start:", ";margin-block-end:", ";display:flex;word-break:break-word;font-size:", ";", ""], ({
  theme
}) => theme.spacing.none, ({
  theme
}) => theme.spacing.none, ({
  theme
}) => theme.typography.size.small, isMobile(css(["font-size:", ";"], ({
  theme
}) => theme.typography.mobile.size.small)));
const DataLabel = /*#__PURE__*/styled.dt.withConfig({
  componentId: "sc-storm-ui-30063520__sc-1r2ixv-5"
})(["font-weight:normal;display:inline;float:none;::after{content:\":\";}"]);
const DataValue = /*#__PURE__*/styled.dd.withConfig({
  componentId: "sc-storm-ui-30063520__sc-1r2ixv-6"
})(["display:inline;float:none;margin-inline-start:", ";"], ({
  theme
}) => theme.spacing.micro);
const DefaultBody = ({
  dataRows,
  image,
  minColumnWidth = 250
}) => /*#__PURE__*/React__default.createElement(Container, null, image && /*#__PURE__*/React__default.createElement(ImageContainer, null, image), /*#__PURE__*/React__default.createElement(Grid, {
  $minColumnWidth: minColumnWidth
}, dataRows.map(({
  label,
  value,
  renderAfter
}, index) => /*#__PURE__*/React__default.createElement(Row, {
  key: index
}, /*#__PURE__*/React__default.createElement(DataItem, null, /*#__PURE__*/React__default.createElement(DataLabel, null, label), /*#__PURE__*/React__default.createElement(DataValue, null, value)), renderAfter && renderAfter))));
DefaultBody.defaultProps = {
  image: undefined,
  minColumnWidth: 250
};

export { DefaultBody as D };
//# sourceMappingURL=DefaultBody-UNbbPDND.js.map
